import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      navigate(user.role === "admin" ? "/admin" : "/hub");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md animate-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-2xl bg-[#E8A87C] flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-head font-extrabold text-xl">WAIT <span className="text-[#E8A87C]">Mental Health</span></span>
        </Link>
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-black/5">
          <h1 className="font-head font-extrabold text-2xl mb-1">Welcome back</h1>
          <p className="text-muted-foreground text-sm mb-6">Let's continue your journey.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-black/10 px-4 py-3 outline-none focus:border-[#E8A87C] transition-colors"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-black/10 px-4 py-3 outline-none focus:border-[#E8A87C] transition-colors"
                data-testid="login-password"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" data-testid="login-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2D3748] text-white font-semibold py-3.5 rounded-full hover:-translate-y-0.5 transition-transform disabled:opacity-60"
              data-testid="login-submit"
            >
              {loading ? "Logging in…" : "Log in"}
            </button>
          </form>
          <p className="text-sm text-center mt-6 text-muted-foreground">
            New here?{" "}
            <Link to="/register" className="font-semibold text-[#E8A87C]" data-testid="login-to-register">
              Create an account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
